// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__19F4y"};